import React from "react";
import InputWrapper from "../../inputs/shared/InputWrapper";
import SelectToggleInput from "../../inputs/SelectToggleInput";

const MermaidChartSelector = ({ selectedChart, setSelectedChart }) => {
  return (
    <SelectToggleInput
      value={selectedChart}
      onChange={(e) => setSelectedChart(e)}
      options={[
        { label: "Flowchart", value: "flowchart" },
        { label: "Sequence Diagram", value: "sequence" },
        { label: "Gantt Chart", value: "gantt" },
        { label: "Pie Chart", value: "pie" },
        { label: "State Diagram", value: "state" },
        { label: "ER Diagram", value: "erDiagram" },
        { label: "Class Diagram", value: "class" },
      ]}
    />
  );
  return (
    <InputWrapper label={"Select Chart Type"}>
      <SelectToggleInput
        value={selectedChart}
        onChange={(e) => setSelectedChart(e)}
        options={[
          { label: "Flowchart", value: "flowchart" },
          { label: "Sequence Diagram", value: "sequence" },
          { label: "Gantt Chart", value: "gantt" },
          { label: "Pie Chart", value: "pie" },
          { label: "State Diagram", value: "state" },
          { label: "ER Diagram", value: "erDiagram" },
          { label: "Class Diagram", value: "class" },
        ]}
      />
    </InputWrapper>
  );
};

export default MermaidChartSelector;
